export const SECTION_TITLES: Readonly<
  Record<"approval" | "requestor" | "resource", string>
> = {
  requestor: "Identity",
  resource: "Resource(s)",
  approval: "Actions",
};
